import { PageLayoutColumns, Panel, Panels } from '@xarvio/layout';

import {
  NewStatusPageListPanelLoading,
  NewStatusPageSidePanelLoading,
} from './NewStatusPageSidePanel/Loading/NewStatusPageSidePanelLoading';
import { FieldStatusDetailsPanelLoader } from '../../components/shared/FieldStatusDetailsPanel/FieldStatusDetailsPanelLoader';
import mapStyles from './NewStatusPageMap/NewStatusPageMap.module.scss';
import { NewStatusPageLoadingPanel } from './NewStatusPageLoadingPanel';

interface NewStatusPageLoadingProps {
  withTitle?: boolean;
  panel?: NewStatusPageLoadingPanel;
}

export const NewStatusPageLoading = ({
  withTitle,
  panel = NewStatusPageLoadingPanel.AllFields,
}: NewStatusPageLoadingProps) => {
  return (
    <PageLayoutColumns shiftForHeader={false}>
      <Panels isFullHeightBelowHeader>
        <NewStatusPageSidePanelLoading withTitle={withTitle} />
        {panel === NewStatusPageLoadingPanel.FieldDetails ? (
          <FieldStatusDetailsPanelLoader />
        ) : (
          <NewStatusPageListPanelLoading size={'s'} />
        )}
        <Panel size={'full'}>
          <div className={mapStyles.mapLoadingShell}>
            <div className={mapStyles.mapPlaceholder} />
          </div>
        </Panel>
      </Panels>
    </PageLayoutColumns>
  );
};
